import { create } from 'zustand';
import type { ChildId } from '~/api/aspida/@types';

interface MfScanState {
  selectedChildren: Record<ChildId, string | undefined>;
  update: (childId: ChildId, mfid: string) => void;
  remove: (childId: ChildId) => void;
  removeByMFID: (mfid: string) => void;
  reset: () => void;
}

export const useMfScanStore = create<MfScanState>((set) => ({
  selectedChildren: {},
  update: (childId, mfid) =>
    set((state) => ({
      selectedChildren: {
        ...state.selectedChildren,
        [childId]: mfid,
      },
    })),
  remove: (childId) =>
    set((state) => ({
      selectedChildren: {
        ...state.selectedChildren,
        [childId]: undefined,
      },
    })),
  removeByMFID: (mfid) =>
    set((state) => {
      const target = Object.keys(state.selectedChildren).find(
        (key) => state.selectedChildren[Number(key)] === mfid,
      );
      if (!target) return state;
      return {
        selectedChildren: {
          ...state.selectedChildren,
          [target]: undefined,
        },
      };
    }),
  reset: () => set({ selectedChildren: {} }),
}));
